/**
 * Created by vladislav on 1/31/2024
 */

const SimpleDataLoader = function () {
    this.localStorage = new HtmlLocalStorage();

    this.data = {};
    this.enabled = true;
};

SimpleDataLoader.prototype.setEnabled = function (enabled) {
    this.enabled = Boolean(enabled);
};

SimpleDataLoader.prototype.getLocalStorage = function () {
    return this.localStorage;
};

SimpleDataLoader.prototype.load = function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!this.data.hasOwnProperty(key)) {
        this.data[key] = this.localStorage.getItem(key);
    }

    const stored = this.data[key];

    if (stored !== null && stored !== undefined && stored !== "undefined") {
        return JSON.parse(stored);
    }

    return undefined;
};

SimpleDataLoader.prototype.save = function (key, data) {
    const string = JSON.stringify(data);

    this.data[key] = string;

    if (this.enabled) {
        this.localStorage.setItem(key, string);
    }
};

SimpleDataLoader.prototype.remove = function (key) {
    delete this.data[key];

    if (this.enabled) {
        this.localStorage.removeItem(key);
    }
};

SimpleDataLoader.prototype.cleanAll = function () {
    this.data = {};

    const prefix = SimpleDataLoader.GetLocalStoragePrefix();

    this.localStorage.clearData(prefix);
};

SimpleDataLoader.GetLocalStoragePrefix = function () {
    return `pc_${connector.config.projectId}${connector.platform.getPlugin().getLocalStoragePrefix()}`;
};

SimpleDataLoader.InitTypes = function () {
    const prefix = SimpleDataLoader.GetLocalStoragePrefix();

    Object.keys(SimpleDataLoader.TYPES).forEach((key) => {
        SimpleDataLoader.TYPES[key] = prefix + SimpleDataLoader.TYPES[key];
    });
};

SimpleDataLoader.GetOldLocalStoragePrefix = function () {
    return connector.config.projectId + connector.platform.getPlugin().getLocalStoragePrefix();
};

SimpleDataLoader.Migrate = function () {
    const prefix = SimpleDataLoader.GetLocalStoragePrefix();
    const oldPrefix = SimpleDataLoader.GetOldLocalStoragePrefix();

    const migrateKey = (key) => {
        const oldKey = key.replace(prefix, oldPrefix);
        if (connector.dataLoader.load(oldKey) && !connector.dataLoader.load(key)) {
            const value = connector.dataLoader.load(oldKey);
            connector.dataLoader.save(key, value);
            return true;
        }
    };

    if (migrateKey(SimpleDataLoader.TYPES.USER_ID)) {
        Object.values(SimpleDataLoader.TYPES).forEach(migrateKey);
    }

    migrateKey(SimpleDataLoader.TYPES.MULTIPLE_CONVERSIONS_INFO);
    migrateKey(SimpleDataLoader.TYPES.PUSHES);
    migrateKey(SimpleDataLoader.TYPES.SYNC);
};

SimpleDataLoader.TYPES = {
    USER_ID: "_user_id",
    METRICS: "_metrics",
    MULTIPLE_CONVERSIONS_INFO: "_multiple_conversions_info",
    MULTIPLE_PREDICTIONS_INFO: "_multiple_predictions_info",
    SHORTCUT_CREATED: "_instant_shortcut_created",
    HOME_SCREEN_ADDED: "_home_screen_added",
    DRAUGIEM_AUTH_DATA: "_draugiem_auth_data",
    XSOLLA_ACCESS_TOKEN: "_xsolla_access_token",
    APPLE_SOCIAL: "_apple_social",
    MS_SOCIAL: "_ms_social",
    TIKTOK_AUTH_DATA: "_tiktok_auth_data",
    PAYMENTS_COUNTRY: "_payments_country",
    XSOLLA2_PAYMENTS_AUTH: "_xsolla2_payments_auth",
    ROBOKASSA: "_robokassa",
    PAYMENTS: "_payments",
    ARKADIUM_PAYMENTS: "_arkadium_payments",
    TESTPAYMENTS: "_test_payments",
    PUSHES: "_local_pushes",
    SYNC_SESSION: "_sync_session",
    SYNC: "_sync",
    SYNC_TRANSPORT: "_sync_transport"
};
